import React from "react";
import "./knowmore.scss";
import { rightWhiteArrow } from "../../source";
import { Link } from "react-router-dom";

const KnowMore = ({ link, text, external, target, button, onclick }) => {
  return (
    <div className="knowmore_sec1">
      {button ? (
        <button className="knowmore_text" onClick={onclick && onclick}>
          <span className="text">{text}</span>
          <img
            src={rightWhiteArrow}
            alt="right arrow"
            className="knowmore_arrow"
          />
        </button>
      ) : external ? (
        <a
          href={link}
          target={`${target ? target : "_blank"}`}
          className="knowmore_text"
        >
          <span className="text">{text}</span>
          <img
            src={rightWhiteArrow}
            alt="right arrow"
            className="knowmore_arrow"
          />
        </a>
      ) : (
        <Link to={link} className="knowmore_text">
          <span className="text">{text}</span>
          <img
            src={rightWhiteArrow}
            alt="right arrow"
            className="knowmore_arrow"
          />
        </Link>
      )}
    </div>
  );
};

export default KnowMore;
